import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"
import { csrfToken } from "../utils/csrf"

// The side panel for a tree person the viewer has no contact for.
//
// Two jobs, both about not being a dead end: give them a real card in your own
// address book, and hand editing back to the tree (which owns the person and
// has the modal).
export default class extends Controller {
    static targets = ["adopt", "adoptLabel"]
    static values = { adoptUrl: String }

    async adopt() {
        if (!this.hasAdoptTarget) return

        this.adoptTarget.disabled = true
        try {
            let response = await fetch(this.adoptUrlValue, {
                method: "POST",
                credentials: "same-origin",
                headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() }
            })
            let data = await response.json().catch(() => ({}))
            if (!response.ok || !data.ok) {
                this.adoptTarget.disabled = false
                showSystemToast(data.error || "Could not add them.")
                return
            }
            showSystemToast(data.notice || "Added to your contacts.")
            // The tree re-reads, so the next click on this person opens their
            // contact card rather than this panel.
            document.dispatchEvent(new CustomEvent("family-tree:reload"))
            // The label, not the button: as a menu item the button also holds
            // an icon, and writing over its text content would delete it.
            let label = this.hasAdoptLabelTarget ? this.adoptLabelTarget : this.adoptTarget
            label.textContent = "Added"
        } catch {
            this.adoptTarget.disabled = false
            showSystemToast("Could not add them.")
        }
    }

    edit(event) {
        let personId = event.currentTarget.dataset.personId
        document.dispatchEvent(new CustomEvent("family-tree:edit-person", { detail: { personId } }))
    }
}
